exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-box[data-v-fd8a1d40] {\n  margin: 12px 0;\n  padding: 0 10px;\n}", ""]);

// exports
